export default "__VITE_PUBLIC_ASSET__97ebd3f8__"